import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import Dialog, {DialogActions, DialogContent, DialogContentText, DialogTitle} from 'material-ui/Dialog'
import TextField from 'material-ui/TextField'
import Button from 'material-ui/Button'

import {share as text} from '../text'
import {share as styles} from '../styles'
import LoadingButton from '../../../common/components/LoadingButton'

class Share extends React.Component {
  render() {
    const {open, setOpen, setEmail, email, share, error, isSaving} = this.props
    return (
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>{text.title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{text.body}</DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label={text.labelEmail}
            type="email"
            fullWidth
            value={email.value}
            onChange={e => setEmail(e.target.value)}
            error={error !== ''}
            helperText={error}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>{text.cancel}</Button>
          <LoadingButton
            color="primary"
            isLoading={isSaving}
            onClick={share}
            type="submit"
          >
            {text.accept}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    )
  }
}

Share.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  setEmail: PropTypes.func,
  email: PropTypes.shape({
    value: PropTypes.string,
    error: PropTypes.string,
  }),
  share: PropTypes.func,
  isSaving: PropTypes.bool,
  error: PropTypes.string,
}

export default withStyles(styles)(Share)



// WEBPACK FOOTER //
// ./src/sections/shared/components/share.js